import { createRoute } from '@tanstack/react-router';
import BookingPage from '@/features/public/booking/pages/BookingPage.tsx';
import { bookingRoute } from '@/features/public/booking/routes/bookingRoutes.ts';

export const bookingTourRoute = createRoute({
  getParentRoute: () => bookingRoute,
  path: '/',
  component: BookingPage,
});
